export const LOGIN = 'auth/FETCH_TOKEN';
export const DESTROY_AUTH_SESSION = 'auth/DESTROY_SESSION';
export const LOGIN_SUCCESS = 'auth/FETCH_TOKEN_SUCCESS';
export const LOGIN_FAILURE = 'auth/FETCH_TOKEN_FAILURE';

export const CLEAR_AUTH_DATA = 'auth/CLEAR_TOKEN';
